export default {
    // apiUrl:'http://127.0.0.1:8080/renren-admin',//接口地址
    apiUrl:'http://kcfw.ccgp-shandong-rz.cn/renren-admin',//接口地址
    loginUrl: 'http://kcfw.ccgp-shandong-rz.cn/xyjq/#login',//后台登陆界面
}




//////////////////
// WEBPACK FOOTER
// ./config/ipConfig.js
// module id = null
// module chunks = 